import type { ClassificationLookupKind } from './types'

/** Bir kataloğun ekran/API ayarı — iki ekran tek bileşenden bu kayıtla ayrışır. */
export interface ClassificationLookupConfig {
  /** Yönetim ucunun taban yolu (`apiClient` önekine göre). */
  apiBase: string
  /** TanStack Query anahtarının kökü — iki kataloğun önbelleği birbirine karışmaz. */
  queryKey: string
  /** Menü etiketi anahtarı; sayfa başlığı da budur (anayasa: başlık = menü adı). */
  menuLabelKey: string
  /** Ekran metinlerinin i18n öneki (`columns`, `form`, `toast` … bunun altında). */
  i18nPrefix: string
  /** Excel dosyasının yedek adı (sunucu Content-Disposition göndermezse kullanılır). */
  exportName: string
}

/**
 * Tür → ayar eşlemesi (127). Yollar backend `StrategicObjectiveAdminController` /
 * `ContributionAdminController` ile, yedek dosya adları oradaki dışa aktarma adlarıyla aynıdır.
 */
export const CLASSIFICATION_LOOKUP_CONFIG: Record<
  ClassificationLookupKind,
  ClassificationLookupConfig
> = {
  strategicObjectives: {
    apiBase: '/management/strategic-objectives',
    queryKey: 'strategic-objectives',
    menuLabelKey: 'nav.admin.strategicObjectives',
    i18nPrefix: 'taskClassifications.strategicObjectives',
    exportName: 'stratejik-hedefler',
  },
  contributions: {
    apiBase: '/management/contributions',
    queryKey: 'contributions',
    menuLabelKey: 'nav.admin.contributions',
    i18nPrefix: 'taskClassifications.contributions',
    exportName: 'katkilar',
  },
}
